import { axiosInstance } from '@configs/axios/axiosInstance';

import type { CountryDto } from './fetchCountries.types';

export async function fetchCountries(): Promise<CountryDto[]> {
  const { data } = await axiosInstance.get<CountryDto[]>('/countries');
  return data;
}
